module.exports = __webpack_public_path__ + "static/media/IMG_043.196096c0.PNG";